import Request from './request'

async function fetch(data) {
    return Request('get', "api/return-orders", data);
}

async function fetchOne(id, data) {// 获取单个
    return Request('get', "api/return-orders/" + id, data);
}

async function fetchRelations(id, data) {// 获取退货单相关单据
    return Request('get', "api/return-orders/relations/" + id, data);
}

function delSomeFields(data) {// 去除过多杂项
    data = JSON.parse(JSON.stringify(data));// 深拷贝避免修改原数据
    delete data.actions;
    delete data.shop;
    delete data.order_activities;
    delete data.bill;
    delete data.creater;
    return data;
}

async function add(data) {// 新建退货单
    data = delSomeFields(data);// 去除过多杂项
    return Request('post', "api/return-orders/add", data);
}

async function getReturnableView(id) {//根据订单ID获取可退商品
    return Request('get', "api/return-orders/get-returnable-view/" + id);
}

export default {
    fetch,
    fetchOne,
    fetchRelations,
    add,
    getReturnableView,
};
